"use strict";

exports.__esModule = true;
exports["default"] = cover;

function cover(offset) {
  if (offset === void 0) {
    offset = 0;
  }

  return {
    position: 'absolute',
    top: offset,
    right: offset,
    bottom: offset,
    left: offset
  };
}

module.exports = exports.default;